import React from "react";
import { Link } from "react-router-dom";

const ServiceBanner = () => {
  return (
    <section className="aprroch">
      <div className="container-2">
        <div className="row align-items-center no-gutters">
          <div className="col-sm-12 col-md-12 col-lg-6 col-xl-7">
            <img src="images/our-approach.jpg" className="img-fluid" alt="" />
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 col-xl-5">
            <div className="our-approach">
              <h2>Our Approach</h2>
              <p>
                Our unique approach brings you the right advice and practical
                guidance for a fresh, perspective, a new lens to reimagine
                what's possible.
              </p>
              <p>
                The Think Outside Gardens team will help you discover and create
                your new outdoor environment.
              </p>
              <Link
                to="/services"
                className="btn btn-grey-border btn-sm-block mt-40 mt-sm-25"
              >
                Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceBanner;
